export const recipes = [
    {
      id: 990,
      categories: "Ana Yemek",
      title: " Etli Nohut Yemeği",
      explanation: "Geleneksel Türk mutfağının vazgeçilmez lezzetlerinden biri olan etli nohut yemeği tarifi.",
      longDescription:
        "Etli nohut yemeği, Türk mutfağının vazgeçilmezlerinden biridir. Et ve nohutun harika uyumuyla hazırlanan bu yemek, lezzetli bir alternatif sunar. İşte havuçlu etli nohut yemeği tarifi:",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686580606/etli_nohut_yeme%C4%9Fi_fk5plu.png",
      manyPerson: "4",
      preparaTiontime: "15",
      cookingTime: "90",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Kurucu",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "500 gr nohut",
        "300 gr dana eti",
        "2 adet havuç",
        "2 adet soğan",
        "3 diş sarımsak",
        "2 yemek kaşığı domates salçası",
        "2 yemek kaşığı sıvı yağ",
        "1 yemek kaşığı tereyağı",
        "1 çay kaşığı şeker",
        "Tuz",
        "Karabiber",
        "Kimyon",
        "Su",
      ],
      preparation: [
        "Nohutları akşamdan su dolu bir kapta ıslatın.",
        "Ertesi gün, nohutları süzün ve yıkayın.",
        "Tencereye sıvı yağı ekleyin ve kızdırın.",
        "Yemeklik doğranmış soğanları ve ezilmiş sarımsakları ekleyerek kavurun.",
        "Küp doğranmış dana etini ekleyin ve etler suyunu salıp çekene kadar kavurun.",
        "Salçayı ekleyerek karıştırın ve kısık ateşte biraz daha kavurun.",
        "Havuçları doğrayın ve tencereye ekleyin, karıştırın.",
        "Süzülmüş nohutları tencereye ekleyin ve karıştırın.",
        "Üzerini geçecek kadar su ekleyin.",
        "Tuz, karabiber, kimyon ve şeker ekleyerek karıştırın.",
        "Tencerenin kapağını kapatın ve orta ateşte nohutlar yumuşayana kadar pişirin. Arada su ekleyebilirsiniz.",
        "Nohutlar yumuşadığında, tereyağını ekleyin ve karıştırın.",
        "Kapağı açık şekilde düşük ateşte yemeği kaynamaya bırakın. Ara ara karıştırarak suyunu çekmesini sağlayın. Bu süre içinde etin ve havuçların iyice piştiğini kontrol edin.",
  
        "Pişme süresi yaklaşık 1,5 - 2 saat olacaktır. Eğer nohutlar hala sertse ve suyu çekilmemişse, pişirme süresini uzatabilirsiniz.",
  
        "Havuçlu etli nohut yemeği, sıcak servis yapılabilir. Yanında pilav veya turşu ile servis edebilirsiniz. Afiyet olsun!",
      ],
    },
    {
      id: 991,
      categories: "Aperatif",
      title: "Dereotlu Puaça",
      explanation: "Mis gibi dereotu aromasıyla leziz bir puaça tarifi.",
      longDescription:
        "Dereotlu puaça, çay saatlerinin vazgeçilmez lezzetlerinden biridir. Taze dereotu ile hazırlanan bu puaçalar, yumuşak ve lezzetli bir hamur ile buluşur. İşte dereotlu puaça tarifi:",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686580607/dereotlu_po%C4%9Fa%C3%A7a_prfepx.png",
      manyPerson: "6",
      preparaTiontime: "30",
      cookingTime: "20",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Kurucu",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "3 su bardağı un",
        "1 su bardağı yoğurt",
        "1 su bardağı sıvı yağ",
        "1 çay bardağı su",
        "1 paket kabartma tozu",
        "1 çay kaşığı tuz",
        "1 demet dereotu",
        "100 gr beyaz peynir",
      ],
      preparation: [
        "Unu bir kaseye alın ve ortasını havuz gibi açın.",
        "Yoğurdu, sıvı yağı, suyu, kabartma tozunu ve tuzu ekleyin.",
        "Yavaşça karıştırarak hamuru yoğurun ve ele yapışmayacak bir kıvam elde edene kadar un ekleyin.",
        "Hamuru streç filme sarın ve 15 dakika dinlendirin.",
        "Dereotunu ince ince doğrayın.",
        "Dinlenen hamurdan ceviz büyüklüğünde parçalar koparıp elinizde yuvarlayın.",
        "Hamurun ortasına biraz doğranmış dereotu ve beyaz peynir koyun.",
        "Hamuru kapatıp yuvarlayarak puaça şekli verin.",
        "Hazırladığınız puaçaları yağlı kağıt serili fırın tepsisine dizin.",
        "Önceden ısıtılmış 180 derece fırında üzeri kızarana kadar pişirin.",
        "Dereotlu puaçaları sıcak veya ılık olarak servis yapabilirsiniz. Afiyet olsun!",
      ],
    },
    {
      id: 992,
      categories: "Tatlı",
      title: "Çikolatalı Sufle",
      explanation:
        "Yoğun çikolata aromasıyla harika bir tatlı olan çikolatalı sufle tarifi.",
      longDescription:
        "Çikolatalı sufle, lezzetli ve göz alıcı bir tatlıdır. İçi yumuşacık ve akışkan çikolata dolgusuyla herkesin beğenisini kazanır. İşte çikolatalı sufle tarifi:",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686580609/sufle_l0nzki.png",
      manyPerson: "4",
      preparaTiontime: "20",
      cookingTime: "15",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Kurucu",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "150 gr bitter çikolata",
        "100 gr tereyağı",
        "3 adet yumurta",
        "75 gr toz şeker",
        "40 gr un",
        "1 çay kaşığı vanilya özütü",
        "Tereyağı ve un (kalıpları yağlamak için)",
      ],
      preparation: [
        "Çikolatayı benmari usulü eritin ve tereyağı ekleyerek karıştırın. Soğumaya bırakın.",
        "Yumurtaları ve toz şekeri mikserle çırpın. Karışım köpürene kadar çırpın.",
        "Eritilmiş çikolata ve tereyağı karışımını yumurtalı karışıma ekleyin. Karıştırın.",
        "Unu ekleyin ve karıştırarak homojen bir hamur elde edene kadar çırpın.",
        "Vanilya özütünü ekleyin ve karıştırın.",
        "Sufle kalıplarını tereyağıyla yağlayın ve unlayın.",
        "Hazırladığınız karışımı sufle kalıplarına paylaştırın.",
        "Önceden ısıtılmış 180°C fırında yaklaşık 12-15 dakika pişirin. Sufleler kabarana kadar pişirin.",
        "Fırından çıkan sufleleri hemen sıcak servis yapın. Üzerine pudra şekeri serpiştirebilirsiniz.",
        "Çikolatalı suflelerinizi sıcak olarak servis edin ve afiyetle yiyin!",
      ],
    },
    {
      id: 993,
      categories: "Ana Yemek",
      title: "Karnıyarık",
      explanation:
        "Türk mutfağının lezzetli yemeklerinden biri olan karnıyarık tarifi.",
      longDescription:
        "Karnıyarık, Türk mutfağının en sevilen yemeklerinden biridir. Patlıcanlar ve iç harcıyla muhteşem bir lezzet oluşturur. Malzemeler hazırsa, karnıyarık tarifimize geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686580606/karn%C4%B1yar%C4%B1k_og4l9v.png",
      manyPerson: "4",
      preparaTiontime: "20",
      cookingTime: "40",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Kurucu",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "4 adet patlıcan",
        "300 gr kıyma",
        "2 adet soğan",
        "2 diş sarımsak",
        "2 adet domates",
        "2 yemek kaşığı sıvı yağ",
        "1 yemek kaşığı tereyağı",
        "1 çay kaşığı toz biber",
        "Tuz",
        "Karabiber",
        "Maydanoz",
      ],
      preparation: [
        "Patlıcanların sap kısımlarını kesin ve uzunlamasına ortadan ikiye bölün.",
        "Tuzlu suda 10-15 dakika bekletin, ardından suyunu sıkarak çıkarın.",
        "Bir tavada sıvı yağı kızdırın ve patlıcanları her iki tarafını da kızartın.",
        "Kızaran patlıcanları bir tabağa alın ve fazla yağını kağıt havluyla alın.",
        "Aynı tavada sıvı yağı tekrar kızdırın ve doğranmış soğanları ekleyerek kavurun.",
        "Sarımsakları ekleyin ve kavurmaya devam edin.",
        "Kıymayı ekleyin ve kavrulana kadar pişirin.",
        "Doğranmış domatesleri ve baharatları ekleyin, karıştırın ve pişirin.",
        "Kıymanın içerisine doğranmış maydanoz ekleyin ve karıştırın.",
        "Kızarmış patlıcanların içerisine hazırladığınız kımyanın harcını paylaştırın ve patlıcanları kapatarak fırın tepsisine yerleştirin.",
        "Üzerlerine dilerseniz rendelenmiş kaşar peyniri serpebilirsiniz.",
        "Önceden ısıtılmış 180 derece fırında yaklaşık 20-25 dakika kadar pişirin.",
        "Karnıyarık sıcak olarak servis yapabilirsiniz. Yanında pilav veya yoğurt ile servis edebilirsiniz. Afiyet olsun!",
      ],
    },
  
    {
      id: 994,
      categories: "Ana Yemek",
      title: "Etli Kuru Fasulye",
      explanation:
        "Geleneksel Türk mutfağının vazgeçilmez lezzetlerinden biri olan etli kuru fasulye tarifi.",
      longDescription:
        "Etli kuru fasulye, Türk mutfağının en sevilen yemeklerinden biridir. Uzun süre pişirilen fasulyeler, et ile birlikte harika bir lezzet oluşturur. Malzemeler hazırsa, etli kuru fasulye tarifimize geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686072346/Ads%C4%B1z_tasar%C4%B1m_21_kqwfbt.png",
      manyPerson: "4",
      preparaTiontime: "15",
      cookingTime: "120",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Kurucu",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "500 gr kuru fasulye",
        "300 gr dana eti",
        "2 adet soğan",
        "3 diş sarımsak",
        "2 yemek kaşığı domates salçası",
        "2 yemek kaşığı sıvı yağ",
        "1 yemek kaşığı tereyağı",
        "1 çay kaşığı şeker",
        "Tuz",
        "Karabiber",
        "Kimyon",
        "Su",
      ],
      preparation: [
        "Kuru fasulyeleri akşamdan su dolu bir kapta ıslatın.",
        "Ertesi gün, fasulyeleri yıkayın ve süzün.",
        "Tencereye sıvı yağı ekleyin ve kızdırın.",
        "Yemeklik doğranmış soğanları ve ezilmiş sarımsakları ekleyerek kavurun.",
        "Küp doğranmış dana etini ekleyin ve etler suyunu salıp çekene kadar kavurun.",
        "Salçayı ekleyerek karıştırın ve kısık ateşte biraz daha kavurun.",
        "Süzülmüş kuru fasulyeleri tencereye ekleyin ve karıştırın.",
        "Üzerini geçecek kadar su ekleyin.",
        "Tuz, karabiber, kimyon ve şeker ekleyerek karıştırın.",
        "Tencerenin kapağını kapatın ve kısık ateşte fasulyeler yumuşayana kadar pişirin. Arada su ekleyebilirsiniz.",
        "Fasulyeler yumuşadığında, tereyağını ekleyin ve karıştırın.",
        "Kapağı açık şekilde düşük ateşte fasulyeleri kaynamaya bırakın. Ara ara karıştırarak suyunu çekmesini sağlayın.",
        "Fasulyelerin suyunu çektiğini ve etlerin tamamen piştiğini kontrol edin.",
        "Pişme süresi yaklaşık 2 saat olacaktır. Eğer fasulyeler hala sertse ve suyu çekilmemişse, pişirme süresini uzatabilirsiniz.",
        "Etli kuru fasulye, sıcak servis yapılabilir. Yanında pilav veya turşu ile servis edebilirsiniz.Afiyet olsun!",
      ],
    },
    {
      id: 995,
      categories: "Salata & Meze",
      title: "Çoban Salata",
      explanation: "Lezzetli ve sağlıklı bir çoban salatası tarifi.",
      longDescription:
        "Çoban salatası, taze sebzelerin harmanlanmasıyla hazırlanan bir salatadır. Malzemeler hazırsa, çoban salata tarifi için detaylara geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686072346/Ads%C4%B1z_tasar%C4%B1m_20_x5ieff.png",
      manyPerson: "4",
      preparaTiontime: "15",
      cookingTime: "0",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "3 adet domates",
        "2 adet salatalık",
        "1 adet yeşil biber",
        "1 adet kırmızı biber",
        "1 adet soğan",
        "200 gr beyaz peynir",
        "Yarım demet maydanoz",
        "Yarım limon",
        "3 yemek kaşığı zeytinyağı",
        "Tuz",
        "Karabiber",
      ],
      preparation: [
        "Domatesleri, salatalıkları, yeşil biberi ve kırmızı biberi küp şeklinde doğrayın.",
        "Soğanı ince doğrayın ve tuzlu suda bekletin.",
        "Beyaz peyniri küp şeklinde doğrayın veya rendeleyin.",
        "Maydanozu ince ince kıyın.",
        "Doğradığınız sebzeleri ve süzdüğünüz soğanı bir salata kabına alın.",
        "Üzerine beyaz peyniri ve kıyılmış maydanozu ekleyin.",
        "Zeytinyağı, limon suyu, tuz ve karabiberi ekleyerek karıştırın.",
        "Salatayı buzdolabında en az yarım saat dinlendirin.",
        "Servis yapmadan önce karıştırarak servis tabağına alın. Afiyet olsun!",
      ],
    },
    {
      id: 996,
      categories: "Ana Yemek",
      title: "Beef Wellington",
      explanation:
        "Beef Wellington, etin mantar dolgusuyla sarılarak fırında pişirildiği lezzetli bir İngiliz yemeğidir.",
      longDescription:
        "Beef Wellington, özellikle özel günlerde sunulan bir yemektir. İçerisinde ince dilimlenmiş dana eti, mantarlı duxelle sosu ve krep hamuru bulunur. Bu özel tarifi denemeye ne dersiniz?",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1686072347/Ads%C4%B1z_tasar%C4%B1m_19_j8mbmc.png",
      manyPerson: "4",
      preparaTiontime: "30",
      cookingTime: "60",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
  
      materials: [
        "800 gr dana filetosu",
        "Tuz",
        "Karabiber",
        "Zeytinyağı",
        "300 gr mantar",
        "2 diş sarımsak",
        "Maydanoz",
        "2 yemek kaşığı tereyağı",
        "12 dilim Parma jambon",
        "2 adet yufka hamuru",
        "2 adet yumurta sarısı",
        "Kızartma yağı",
      ],
      preparation: [
        "Dana filetosunu tuz ve karabiberle ovun.",
        "Zeytinyağını tavada kızdırın ve filetoyu her iki tarafını da kızartın.",
        "Kızartılan filetoyı dinlenmesi için bir kenara alın.",
        "Mantarları doğrayın, sarımsakları ezin ve maydanozu ince şekilde doğrayın.",
        "Tereyağını tavada eritin ve mantarları ekleyin. Mantarlar suyunu salıp çekene kadar kavurun.",
        "Sarımsakları ekleyin ve karıştırın.",
        "Karışıma ince doğranmış maydanozu ekleyin ve karışımı ocaktan alın.",
        "Bir yufka hamurunu düz bir zemine serin.",
        "Üzerine dilimlenmiş Parma jambonu yerleştirin.",
        "Mantarlı karışımı jambonun üzerine yayın.",
        "Kızartılmış dana filetosunu karışımın üzerine yerleştirin.",
        "Yufka hamurunun kenarlarını filetonun üzerine kapatın ve yufkayı sıkıca sarın.",
        "İkinci yufka hamurunu da düz bir zemine serin.",
        "Üzerine bir dilim Parma jambon yerleştirin.",
        "Mantarlı karışımı jambonun üzerine yayın ve filetoyu sarılmış yufka hamurunun üzerine yerleştirin. Yufkayı sıkıca sararak etin tamamen kaplanmasını sağlayın.",
        "Yumurta sarılarını çırpın ve yufka hamurunun üzerine sürün.",
        "Önceden ısıtılmış 180 derece fırında, üzeri güzelce kızarana kadar yaklaşık 40-45 dakika pişirin.",
        "Pişen Beef Wellington'ı fırından çıkarın ve biraz dinlenmesi için bekletin.",
        "Daha sonra dilimleyerek servis yapın.",
        "Beef Wellington'ı dilerseniz yanında püre patates veya sebzelerle servis edebilirsiniz. Afiyet olsun!",
      ],
    },
  
    {
      id: 997,
      categories: "Tatlı",
      title: "Tatlı Dilek",
      explanation: "Masterchef Türkiye'de Mehmet Şef'in imza tabağı  Tatlı Dilek",
      longDescription:
        "Masterchef Türkiye'de Mehmet Şef'in imza tabağı olan tatlı dilek yapımında, krem fontana ve sifon kek kullanılır. Tatlının üzerinde birbirinden farklı meyveler kullanılır. Malzemeler hazırsa, Mehmet Şef'ten tatlı dilek tarifi için detaylara geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1685746157/tatl%C4%B1dilek_tyqpe8.png",
      manyPerson: "2",
      preparaTiontime: "20",
      cookingTime: "40",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "Limon",
        "Bal",
        "Toz şeker",
        "Granül kahve",
        "Kestane şekeri",
  
        "Taze fesleğen",
        "Bal",
        "Kestane şekeri",
  
        "30 gr un",
        "Tuz",
        "Mürekkep balığı mürekkebi",
        "220 gr beyaz pralin",
        "180 gr yumurta beyazı",
        "Bronz toz boya",
  
        "Yağ bazlı siyah gıda boyası",
        "Kakao yağı",
        "Dekor jelatini",
        "Beyaz para çikolata",
        ,
        "Böğürtlen",
        "Frenk üzümü",
        "Frambuaz",
        "Altın çilek",
        "Kumkuat",
      ],
      preparation: [
        "Krem fontana için; Tencereye süt, krema, rendelenmiş zencefil ve vanilya çubuğunu ekleyerek sürekli karıştırın ve kaynatın.",
        "Başka bir tencerede yumurta sarısı ve toz şekeri karıştırarak ılıtın. Ama kaynatmayın.",
        "Ilıyan yumurta sarısının için, diğer karışımı yavaş yavaş karıştırarak ekleyin.",
        "Suda beklettiğiniz yaprak jelatinleri de ekleyin ve karıştırın.",
        "Krem fontanayı, 2 ayrı karıştırma kabına paylaştırın.",
        "Başka bir tavada toz şeker ile karamel yapın. İçine bal ekleyerek biraz soğutun.",
        "Kaplardan birinde olan krem fontanaya ballı karışımı ve granül kahveyi ekleyerek karıştırın.",
        "Bu karışımı bardakların tabanına eşit miktarda paylaştırarak soğutucuya atarak dondurun.",
        "Alt kısmı donduktan sonra, zencefilli krem fontanayı eşit miktarda üzerine ekleyin ve dondurun.",
        "Kestane sosu için; Tavaya kestane şekerini alın. Kaşık ile ezin. Üzerine bal ve kremayı ekleyip kaynatın.",
        "Fesleğen yapraklarını ince ince doğrayıp içine ilave edin. İyice kaynayan ve kıvam alan sosu, ocaktan alın ve soğuması için bir süre bekleyin.",
        "Donmuş krem fontanaların üzerine bu karışımı ekleyin ve tekrar dondurucuya atın.",
        "Sifon kek için; Beyaz pralin, un, tuz, yumurta beyazı ve mürekkep balığı mürekkebini alarak iyice köpürene kadar çırpın.",
        "Sifonun içerisine doldurup kapağını kapatın ve 2 tane gaz tüpünü içerisine doldurun. Karton bardaklara sıkarak mikrodalgada 40 saniye-1 dakika arası pişirin.",
        "Bardakları kestikten sonra kekleri içinden çıkartın. Üzerini bronz toz boya ile kaplayın.",
        "Çikolata dekoru için; Kakao yağını eritin ve siyah gıda boyası ile karıştırın.",
        "Karıştırarak soğutun ve dekor jelatinin üzerine yayarak donmaya bırakın.",
        "Beyaz para çikolatalarını eritin. Dekor jelatinin üzerine ince bir tabaka halinde yayın. Bardağın üzerini kapatacak boyda bir çember ile çikolataları kesin.",
        "Krem fontanayı dolaptan çıkartın. Cımbız yardımıyla sifon keki orta kısma yerleştirin.",
      ],
    },
    {
      id: 998,
      categories: "Ana Yemek",
      title: "Taş Havuz",
      explanation: "Masterchef Türkiye'de, Somer Şef'in imza tabağı  Taş Havuz",
      longDescription:
        "Kıbrıs'ın sevilen lezzetlerinden birini sizlerle paylaşmak isteriz. Şeftali kebabı Kıbrıs'a ait bir kebaptır. Koyun veya keçinin gömlek yağından yapılır. Gömlek yağının içerisine kıymalı harç koyularak pişirilir. Şişte veya ızgarada pişirilmesi önerilir. Malzemeler hazırsa, Kıbrıs usulü şeftali kebabı tarifine geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1685746158/ta%C5%9F_havuz_zbxast.png",
      manyPerson: "2",
      preparaTiontime: "25",
      cookingTime: "40",
      shareRecipe: [
        {
          name: "Mustafa ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mustafataslantas@mizanplas.net",
          image: "",
        },
      ],
      materials: [
        "Zeytinyağı",
        "Köz kömür",
        "Siyah midye",
        "Mürekkep",
        "Ayçiçek yağı",
        "Pirinç kağıdı",
        "Agar agar",
        "Nar",
        "Sarımsak",
        "Sazan yumurtası",
        "Deniz tuzu",
        "Arpacık soğan",
        "Üzüm çekirdeği yağı",
        "Buz",
        "Limon",
        "Portakal",
        "Kerevit",
        "Frank soğan",
        "Chili biber",
        "Tuz",
        "Biberiye",
        "Deniz tarağı",
        "Kakao yağı",
        "Miso",
        "Patlıcan",
        "Karnabahar",
        "Sirke",
        "Pancar",
      ],
      preparation: [
        "Deniz börülcelerini blanch edin ve kılçıklarını temizleyin.",
        "Pirinç cipsine mürekkep sürün ve kızartın.",
        "İsli midye için; Zeytinyağını bir kaba doldurun. İçine daha küçük bir kap koyun ve blanch edilmiş isli midyeyi ekleyin. Yağın içine közlenmiş kömür parçası ekleyin. İki kap iç içe olacak şekilde streçleyin. 20 dakika bu şekilde bekletin.",
        "Cips için; Fırça yardımıyla kalamar mürekkebi pirinç yaprağına sürün. Daha sonra kızartın.",
        "Nar havyarı için; Taze sıkılmış nar suyunu 100 dereceye getirin. Agar agar ekleyerek kıvam verin. Soğuk zeytinyağına donmadan hızlı bir şekilde, bir şırınga yardımıyla dökün.",
        "Tarama için; Tüm malzemeler miksere alın ve karıştırın. Ürün kıvam alınca, limon suyu ve buzlu su damlatılarak istenen kıvama ulaşın.",
        "Deniz tarağı için; Bir tavanın içinde önce kakao yağını eritin. Daha sonra diğer malzemeleri ilave ederek deniz tarağını kızartın.",
        "Misolu patlıcan için; Patlıcan ve sarımsakları közleyin. Közlendikten sonra içine miso ekleyin ve blenderdan geçirin.",
        "Mercan için; Karnabaharı yuvarlak şekilde kesin. Pancar, sirke ve tuz ekleyip haşlayın. Ardından suyunu süzüp buzlu su içine alın.",
        "Ceviche için; Tüm malzemeleri ufak ufak kesin. Limon ve portakal suyunda bekletin.",
        "Tabağın alt kısmını midye kabuklarıyla doldurun. Üzerine deniz tarağının kabuklarını koyun.  ",
        " Kabukların içine miso patlıcan, deniz tarağı ve nar havyarı ekleyin.",
        "Mısır patlaklarını da tabağa alın ve üzerine isli midyeleri ilave edin. Kerevitin sırtına ceviche doldurun.",
        "Tabağın ortasına yerleştirin. Belirli noktalara tarama sıkın ve otlarla süsleyin.",
      ],
    },
    {
      id: 999,
      categories: "Ana Yemek",
      title: "Şeftali Kebabı",
      explanation:
        "Kıbrıs'ın sevilen lezzetlerinden birini sizlerle paylaşmak isteriz. Şeftali Kebabı ",
      longDescription:
        "Kıbrıs'ın sevilen lezzetlerinden birini sizlerle paylaşmak isteriz. Şeftali kebabı Kıbrıs'a ait bir kebaptır. Koyun veya keçinin gömlek yağından yapılır. Gömlek yağının içerisine kıymalı harç koyularak pişirilir. Şişte veya ızgarada pişirilmesi önerilir. Malzemeler hazırsa, Kıbrıs usulü şeftali kebabı tarifine geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1685746308/%C5%9Feftlikebab%C4%B1_vycmjn.png",
      manyPerson: "5",
      preparaTiontime: "15",
      cookingTime: "30",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "300 gr yağsız kıyma ",
        "Gömlek Yağı ",
        "1 adet soğan ",
        "4-5 dal maydanoz ",
        "2-3 yemek kaşığı galeta unu ",
        "1 çay kaşığı kimyon ",
        "1 çay kaşığı tuz",
        "1 çay kaşığı karabiber",
      ],
      preparation: [
        "Soğanı rendeleyin. Fazla suyunu sıkarak bir kaba alın. ",
        "Maydanozu ince ince doğrayın ve soğanın yanına ekleyin.",
        "Galeta unu ve baharatları ilave edin. ",
        "Kıyma ile birlikte yoğurun. ",
        "Yıkanan ve temizlenen gömlek yağından parçaları tezgaha serin. ",
        "Köfteleri porsiyonladıktan sonra gömlek yağının içerisine sarın. ",
        "Izgarada ya da şişte pişirin. Afiyet olsun. ",
      ],
    },
    {
      id: 1000,
      categories: "Salata & Meze",
      title: "Uskumru Tarator",
      explanation:
        "Füme uskumru ve krema'nın eşşiz uyumu ile hazırlanan uskumru tarator, balık sevmeyenleri bile kendine hayran bırakacak bir mezedir.",
      longDescription:
        "Füme uskumru ve krema ile hazırlanan uskumru tarator, balık sevmeyenleri bile kendine hayran bırakacak bir mezedir. Yemeklerin yanında sunabileceğiniz bu meze, ortalama 30 dakikada hazırlanır. Tarifte kullanacağınız uskumrunun, tamamen kılçıksız olması gerekir. Malzemeler hazırsa, uskumru tarator yapımına geçebiliriz.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1685746158/uskumrutarator_gjgy4f.png",
      manyPerson: "4",
      preparaTiontime: "15",
      cookingTime: "15",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1685746158/uskumrutarator_gjgy4f.png",
        },
      ],
      materials: [
        "250 gram füme uskumru",
        "4 yemek kaşığı çiğ krema ",
        "Yarım limonun suyu",
        "1 adet orta boy soğan ",
        "2 yemek kaşığı zeytinyağı",
        "Yeterince beyaz toz biber",
      ],
      preparation: [
        "Füme uskumruların kılçıklarını temizleyin. ",
        "Soğanı ince ince doğrayın. Zeytinyağı ile birlikte karamelize edin.",
        "Bir karıştırma kabına soğan dışında bütün malzemeleri ekleyin ve blenderdan geçirin.",
        "Püre haline gelmiş tarator üzerine karamelize soğan eklenerek servis edilir. Afiyet olsun. ",
      ],
    },
    {
      id: 1001,
      categories: "Çorba",
      title: "Mercimek Çorbası",
      explanation:
        "Türk mutfağının vazgeçilmezlerinden birisi olan, lezzetli ve besleyici bir çorba olan mercimek çorbası.",
      longDescription:
        "Kırmızı mercimek, soğan, sarımsak, havuç ve patates gibi malzemelerle zenginleştirilen bu çorba, hem kolay hazırlanır hem de doyurucu bir öğün sunar. Mercimeklerin püre kıvamına gelene kadar pişirildiği bu tarif, sıcak servis edildiğinde hem gözleri hem de mideleri mutlu eder. Limon dilimleri ve taze maydanozla servis edilerek çorbaya tazelik ve ferahlık katılır. Hem pratik hem de lezzetli bir çorba arayanlar için ideal bir seçenektir.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1684358724/Ads%C4%B1z_tasar%C4%B1m_10_cbeaur.png",
      manyPerson: "4",
      preparaTiontime: "10",
      cookingTime: "30",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "1 su bardağı kırmızı mercimek",
        "1 adet soğan",
        "2 diş sarımsak",
        "1 yemek kaşığı domates salçası",
        "6 su bardağı su",
        "1 yemek kaşığı tereyağı veya sıvı yağ",
        "1 çay kaşığı kırmızı biber",
        "1 çay kaşığı kimyon",
        "Tuz",
        "Karabiber",
        "Limon dilimleri ve maydanoz yaprakları (servis için)",
      ],
      preparation: [
        "Mercimeği yıkayıp süzün.",
        "Soğanı doğrayın, sarımsakları ezin.",
        "Tencerede tereyağı veya sıvı yağı eritin.",
        "Soğanları ve sarımsakları ekleyip pembeleşene kadar kavurun.",
        "Domates salçasını ekleyip kısa bir süre daha kavurun.",
        "Yıkanmış mercimekleri tencereye ekleyin ve karıştırın.",
        "Su, tuz, karabiber, kimyon ve kırmızı biberi ekleyin.",
        "Tencerenin kapağını kapatın ve mercimekler yumuşayana kadar orta ateşte pişirin (yaklaşık 25-30 dakika).",
        "Pişen çorbayı blendır veya çatalla püre haline getirin.",
        "Servis yaparken üzerine limon dilimleri ve maydanoz yaprakları ekleyebilirsiniz.",
      ],
    },
    {
      id: 1002,
      categories: "Pilav & Makarna",
      title: "Mısırlı Pirinç Pilavı",
      explanation:
        "Özellikle Et ve Tavuk Yemekleri yanında vazgeçilmez lezzet, Mısırlı Pirinç Pilavı",
      longDescription:
        "Özellikle Et ve Tavuk Yemeklerinin vazgeçilmezi mısırlı pirinç pilavı. Konserve olarak alınan veya taneleri ayıklanan mısır, pirinç pilavına lezzet katan besinler arasında yer alır Kısa sürede hazırlayarak sofarnızın baş köşesine koyacağınız vazgeçilmez lezzet.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1684358724/Ads%C4%B1z_tasar%C4%B1m_11_gjbw5i.png",
      manyPerson: "6",
      preparaTiontime: "10",
      cookingTime: "15",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "2 su bardağı pirinç",
        "3 su bardağı tavuk suyu",
        "1 kase haşlanmış mısır",
        "Tereyağı",
        "Kestane şekeri",
        "Sıvı yağ",
        "Tuz",
      ],
      preparation: [
        "Pirinçleri sıcak tuzlu suda bir saat bekletelim. Süzdürdükten sonra soğuk su ile iyice yıkayalım.",
        "Tenceremize sıvı yağ ve tereyağı koyalım. İyice yıkanmış pirinçleri içine katıp 5 dk kavuralım..",
        "Mısırları da katıp bir iki dk daha kavuralım. Tuzunu katalım.",
        "3 su bardağı tavuk suyunu döküp iyice kaynadıktan sonra altını kısıp kapağını kapatalım. Suyunu çekene kadar pişirelim. Demlendirip servis edelim. Afiyet olsun",
      ],
    },
    {
      id: 1003,
      categories: "Ana Yemek",
      title: "Patateli Havuçlu Etli Güveç",
      explanation:
        "Enfes bir lezzet deneyimi sunan geleneksel bir lezzet, Patatesli Havuçlu Etli Güveç",
      longDescription:
        "Patatesli Havuçlu Etli Güveç, enfes bir lezzet deneyimi sunan geleneksel bir yemektir. Bu tarifte, mükemmel uyum sağlayan dana eti, patates, havuç ve baharatlar bir araya gelerek muhteşem bir güveç oluşturuyor. Etlerin özenle kavrulduğu, sebzelerin yumuşak ve aromatik olduğu bu güveç, lezzet avcılarının favorisi haline gelmeye aday. Sıcak ve doyurucu bu yemek, misafirlerinizi ve sevdiklerinizi şımartmanın harika bir yoludur. Hem hazırlaması kolay hem de sunumu göz alıcı olan Patatesli Havuçlu Etli Güveç, sofralarınıza lezzet ve keyif katmak için ideal bir seçenektir.",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1684306145/Ads%C4%B1z_tasar%C4%B1m_9_rzcq3n.png",
      manyPerson: "4",
      preparaTiontime: "30",
      cookingTime: "80",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "500 gram dana eti (kuşbaşı şeklinde)",
        "2 adet büyük boy patates (küp doğranmış)",
        "2 adet havuç (halka şeklinde dilimlenmiş)",
        "1 adet soğan (yemeklik doğranmış)",
        "3 diş sarımsak (ezilmiş)",
        "2 yemek kaşığı domates salçası",
        "2 su bardağı sıcak su",
        "2 yemek kaşığı sıvı yağ",
        "1 çay kaşığı pul biber",
        "1 çay kaşığı kekik",
        "Tuz",
        "Karabiber",
      ],
      preparation: [
        "Bir tencereye sıvı yağı ekleyin ve ısıtın.",
        "Kuşbaşı doğranmış dana etini ekleyin ve suyunu salıp çekene kadar kavurun.",
        "Doğranmış soğanı ve ezilmiş sarımsağı ekleyin. Soğanlar pembeleşene kadar kavurun.",
        "Domates salçasını ekleyin ve kavurmaya devam edin.",
        "Patatesleri ve havuç dilimlerini ekleyin. Birkaç dakika karıştırarak kavurun.",
        "Sıcak suyu ekleyin ve karıştırın.",
        "Tuz, karabiber, pul biber ve kekiği ekleyin. Karıştırarak kaynamaya bırakın.",
        "Kaynadıktan sonra ateşi kısın ve güvecin kapağını kapatın.",
        "Etler ve sebzeler yumuşayıncaya kadar, yaklaşık 1 saat pişirin.",
        "Sıcak olarak servis yapın.",
      ],
    },
    {
      id: 1004,
      categories: "Tatlı",
      title: "Fırında Sütlaç",
      explanation:
        "Türk mutfağının sevilen tatlılarından, kremsi ve pürüzsüz bir kıvama sahip olan Fırında Sütlaç",
      longDescription:
        "Fırında Sütlaç, Türk mutfağının en sevilen ve geleneksel tatlılarından biridir. Kremsi dokusu ve lezzetli vanilya aromasıyla, birçok kişinin favori tatlılarından biridir. Fırında pişirilerek elde edilen altın rengi üst tabakasıyla da görsel olarak oldukça çekici bir görünüme sahiptir. ",
      img: "https://res.cloudinary.com/dd4d48hwn/image/upload/v1684306145/Ads%C4%B1z_tasar%C4%B1m_8_i9eik8.png",
      manyPerson: "4-6",
      preparaTiontime: "15",
      cookingTime: "30-40",
      shareRecipe: [
        {
          name: "Mehmet ASLANTAŞ",
          membershipStatus: "Founder",
          email: "mehmetaslantas@mizanplas.net",
          image:
            "https://res.cloudinary.com/dd4d48hwn/image/upload/v1682791174/mehmetaslanta%C5%9F_aojjvf.jpg",
        },
      ],
      materials: [
        "1 litre süt",
        "1 su bardağı toz şeker",
        "Yarım su bardağı pirinç",
        "2 yemek kaşığı pirinç unu",
        "1 tatlı kaşığı vanilya özütü",
        "1 çay kaşığı rendelenmiş limon kabuğu",
        "1 çay kaşığı tarçın (isteğe bağlı)",
        "2 yemek kaşığı tereyağı (eritilmiş)",
        "1 çay kaşığı tuz",
        "3 adet yumurta sarısı",
        "1 yemek kaşığı nişasta (isteğe bağlı)",
      ],
      preparation: [
        "Fırını 180 dereceye ayarlayın ve ısıtmaya başlayın.",
        "Bir tencereye sütü ekleyin ve orta ateşte ısıtın. Süt kaynamaya başladığında altını kısın.",
        "Ayrı bir kapta pirinci yıkayın ve süzün.",
        "Yıkanmış pirinci kaynar sütün içine ekleyin. Karıştırarak pirinçlerin yumuşamasını sağlayın. Arada karıştırarak, yaklaşık 15-20 dakika pişirin.",
        "Toz şekeri ekleyin ve karıştırarak eritin.",
        "Pirinçler iyice piştiğinde tencereyi ocaktan alın.",
        "Pirinç ununu, vanilya özütünü, rendelenmiş limon kabuğunu, tarçını (isteğe bağlı), eritilmiş tereyağını ve tuzu ekleyin. Karıştırarak tüm malzemelerin iyice birleşmesini sağlayın.",
        "Yumurta sarılarını ekleyin ve hızlıca karıştırın. Bu aşamada nişasta kullanmak isterseniz, nişastayı da ekleyin ve karıştırmaya devam edin.",
        "Karışımı fırın kabına dökün. Üzerini düzleştirerek pürüzsüz bir görünüm elde edin.",
        "Fırın kabını, önceden ısıttığınız 180 derece fırında yaklaşık 30-40 dakika pişirin. Sütlaç, üstü hafif kızarana ve kıvamı iyice yoğunlaşana kadar pişmeye devam etmelidir.",
        "Pişen sütlaçları fırından çıkarın ve oda sıcaklığına gelmesini bekleyin.",
        "Oda sıcaklığına geldikten sonra sütlaçları buzdolabına kaldırın ve iyice soğuması için birkaç saat bekletin.",
        "Servis yapmadan önce üzerini tarçın veya hindistan cevizi ile süsleyebilirsiniz.",
      ],
    },
  ];
  export default recipes;
  